import { postRequest } from "../../config/AxiosConfig";
import API_URLS from "../../config/BackendConfig";
import { getToken } from "../../utils/tokenUtils";
const apiBaseUrl = API_URLS.CUSTOMER; 


const getAuthHeaders = () => {
  const token = getToken();
  return token ? { Authorization: `Bearer ${token}` } : {};
};


export const setLowBalanceAlert = async (payload) => {
  try {
  
    const response = await postRequest({
      url: apiBaseUrl + "low-balance-alert",
      headers: getAuthHeaders(),
      data: payload,
    });
    return(response);
  } catch (error) {
    console.error('Error in setting alert', error.response?.data || error.message);
    throw error;
  }
};